export default [
	{
		language: 'en',
		label: 'English',
		flag_iso: 'us'
	},
	{
		language: 'es',
		label: 'Spanish',
		flag_iso: 'es'
	}
]
